var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaratLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5l6.387 6.675a1.054 1.054 0 001.524-1.458L2.827 7.5l5.084-5.217A1.054 1.054 0 106.387.826L0 7.5z",
    fill: "#000"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjE1IiB2aWV3Qm94PSIwIDAgOSAxNSIgZmlsbD0iIzAwNkVBRCI+CiAgPHBhdGggZD0iTTMuMzA3MjZlLTA1IDcuNTAwMTRMNi4zODcyIDE0LjE3NDdDNi43ODk4MyAxNC41OTU2IDcuNDU2NjQgMTQuNjA5NiA3Ljg3NzU0IDE0LjIwNzdDOC4yOTg0MyAxMy44MDUxIDguMzEyNDggMTMuMTM4MyA3LjkxMDU2IDEyLjcxNzRMMi44MjY5NyA3LjUwMDE0TDcuOTEwNTYgMi4yODI5QzguMzEzMTggMS44NjIwMSA4LjI5ODQzIDEuMTk1MTkgNy44Nzc1NCAwLjc5MjU2NEM3LjQ1NzM1IDAuMzg5OTQyIDYuNzg5ODMgMC40MDQ3IDYuMzg3MiAwLjgyNTU5MUwzLjMwNzI2ZS0wNSA3LjUwMDE0WiIgZmlsbD0iIzAwNkVBRCIgLz4KPC9zdmc+";
export { SvgIconCaratLeft as ReactComponent };